import { GlobalActions } from "redux-subspace";
import { actionTypes } from "redux-form";
import { types } from "data/spreedly";

Object.keys(actionTypes).forEach((key) => GlobalActions.register(actionTypes[key]));

GlobalActions.register(types.SET_TOKEN);
GlobalActions.register(types.SET_VALIDITY);
GlobalActions.register(types.SET_VALIDATION_ERRORS);
GlobalActions.register(types.SET_TRIGGER_VALIDATION);
